import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { ContainerSize } from '@freelancer/ui/container';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-navigation-secondary-profile',
  template: `
    @if (showSecondaryNav$ | flAsync) {
      <app-bar
        i18n-appBarTitle="Secondary navigation my profile bar title"
        appBarTitle="My Profile"
        link="/me"
        flTrackingSection="SubnavProfile"
        [containerSize]="containerSize"
      >
        <!--
        Considering this subnav is only shown on self user's profile page
        just highlight Improve Profile permanently
        -->
        <app-bar-item
          link="/me"
          i18n="Secondary navigation my profile bar item"
          flTrackingLabel="ImproveProfile"
          [linkIsActiveOverride]="true"
        >
          Improve Profile
        </app-bar-item>
        <app-bar-item
          *flFeature="Feature.EXAMS"
          link="/exam/exams/index.php"
          i18n="Secondary navigation my profile bar item"
          flTrackingLabel="GetCerified"
          [queryParams]="{ ttref: 'Exams_Profile' }"
          [exactLink]="true"
        >
          Get Certified
        </app-bar-item>
        <app-bar-item
          *flFeature="Feature.REFER_A_CLIENT"
          link="/hireme"
          i18n="Secondary navigation my profile bar item"
          flTrackingLabel="PromoteProfile"
          [exactLink]="true"
        >
          Promote Profile
        </app-bar-item>
        <app-bar-item
          *flFeature="Feature.GAMIFICATION"
          link="/users/game"
          i18n="Secondary navigation my profile bar item"
          flTrackingLabel="MyRewards"
          [exactLink]="true"
        >
          My Rewards
        </app-bar-item>
      </app-bar>
    }
  `,
  styleUrls: ['./navigation-secondary-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationSecondaryProfileComponent implements OnInit {
  private featureFlag = inject(FeatureFlagsService);

  Feature = Feature;
  @Input() containerSize: ContainerSize;

  showSecondaryNav$: Observable<boolean>;

  ngOnInit(): void {
    this.showSecondaryNav$ = this.featureFlag
      .getFlag(Feature.MOVE_SECONDARY_NAV_LINKS)
      .pipe(map(isEnabled => !isEnabled));
  }
}
